import axios from './axios'

export const getCategories = async () => {
  const { data } = await axios.get(`/category`)
  return data
}
export const storeCategory = async payload => {
  const { data } = await axios.post(`/category`, payload)
  return data
}
export const updateCategory = async payload => {
  const { data } = await axios.put(`/category/${payload._id}`, payload)
  return data
}
export const destroyCategory = async id => {
  await axios.delete(`/category/${id}`)
}
